import React, { Component } from 'react';
import './styles.css';
import { connect } from 'react-redux';
import cruceros from '../../../assets/crucero/crucero.jpg';
// import ScrollAnimation from 'react-animate-on-scroll';
import layout from '../../../common/layout';
import ModalForm from '../../common/modal';
import { typeReservationActions } from '../../../redux/typeReservation';
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';

let lang = spanish;

class Crucero extends Component {
  constructor() {
    super();
    this.state = {
      open: false
    }
  }

  componentWillReceiveProps(next) {
    // console.log(next);
    if (next.language === 'spanish') {
      lang = spanish;
    }
    else {
      lang = english;
    }
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.setCurrentReservationType('cruiser');
  }

  handleClose = () => {
    this.setState({ open: false })
  }


  render() {
    const { open } = this.state;
    const listItems = lang.component02Cruise.places.map((item, key) =>
      <li key={key} >{item}</li>
    );
    return (
      <div  id="cruises">
        <div style={{ marginTop: layout.componentStyle.marginTop }}>
          <p className="mainTitle">{lang.component02Cruise.title}</p>
          <div className="containerCruseros" style={{ marginTop: layout.componentStyle.marginTop }}>
            {/* CRUISES IMG */}
            <div className="imgContainer">
              <img alt="cruise" src={cruceros} width='100%' />
            </div>
            {/* INFO CRUISES */}
            <div className="informationContainer" style={{ backgroundColor: layout.grayBackground }}>
              <h1 className="title">{lang.component02Cruise.topic}</h1>
              <p className="description">{lang.component02Cruise.description}</p>
              <ul>
                {listItems}
              </ul>
              <div className="preReservationButton" style={{backgroundColor:layout.gold}} onClick={()=>{this.handleOpen()}}>
              {lang.component02Cruise.reserve}
            </div>
            </div>
            {/*  */}
          </div>
        </div>
        <ModalForm
          open={open}
          handleClose={this.handleClose}
        />
      </div>

    );
  }
}

const mapStateToProps = state => ({
  language: state.LanguageReducer.language,
});

const mapDispatchToProps = dispatch => ({
  setCurrentReservationType: (reservationType) => {
    dispatch(typeReservationActions.setTypeReservation(reservationType));
  },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Crucero);

